import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
import { StyledHelp } from "../../styles/components/NavBarStyles";
import {
    getRouteFromName,
    getUserRoleByRoute,
} from "../../model/Enums/RoutesEnum";
import HelpService from "../../service/Docente/HelpService";
import GenericUtils from "../../utils/GenericUtils";
import { UserRole } from "../../model/Enums/UserRoleEnum";
import { Document } from "../../context/interfaces/IHelpContext";
import ModalHelp from "./ModalHelp";
import {
    IBlobStorage,
    getAccountFromBlobUrl,
    getBlobStorageString,
    getSasTokenFromBlobUrl,
} from "../../utils/BlobDownload";

const CONTAINER_NAME = "filehelp";

const NavbarHelp = () => {
    const [blobContent, setBlobContent] = useState<Blob | undefined>();
    const [showModal, setShowModal] = useState<boolean>(false);

    const { instance } = useMsal();
    const location = useLocation();
    const typeFile = "DOWNLOAD";

    const pathLocation = location.pathname.split("/");

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const getCreatedHelp = async (
        userRole: UserRole | null
    ): Promise<Document | null> => {
        const response = await HelpService.getImportedDocumentByFeatureId(
            instance,
            userRole
        );

        if (
            GenericUtils.isSuccessStatus(response) &&
            response.data &&
            response.data?.id
        ) {
            return response.data;
        }

        return null;
    };

    const getHelpUrl = async () => {
        setBlobContent(undefined);

        const routeEnum = getRouteFromName(pathLocation[1]);
        const userRole = getUserRoleByRoute(routeEnum);
        const createdHelp = await getCreatedHelp(userRole);

        if (!createdHelp) return;

        const response = await HelpService.getFileUrl(
            instance,
            userRole,
            createdHelp.fileName,
            typeFile
        );

        if (
            GenericUtils.isSuccessStatus(response) &&
            response.data &&
            response.data?.link.length
        ) {
            const url = response.data?.link;

            const blobParams: IBlobStorage = {
                account: getAccountFromBlobUrl(url),
                sas: getSasTokenFromBlobUrl(url),
                containerName: CONTAINER_NAME,
                blobName: createdHelp.fileName,
            };
            const newBlobContent = await getBlobStorageString({
                ...blobParams,
            });
            setBlobContent(newBlobContent);
        } else {
            setBlobContent(undefined);
        }
    };

    useEffect(() => {
        getHelpUrl();
    }, [pathLocation[1]]);

    return blobContent ? (
        <>
            <StyledHelp onClick={() => handleOpenModal()}>Ajuda</StyledHelp>

            {showModal && (
                <ModalHelp
                    open={showModal}
                    onClose={handleCloseModal}
                    pdfContent={blobContent}
                />
            )}
        </>
    ) : null;
};

export default NavbarHelp;
